<template><!--mobile -->
    <el-row class="home-wrapper mobile">
        <el-col :span="24" class="home-header">
            <el-col :span="10" class="logo"
                    :class="$organization.menu_class + ' ' + (collapsed?'logo-collapse-width':'logo-width')">
                <img :src="logo" v-show="!collapsed"/>
            </el-col>
            <el-col :xs="1" :span="10" class="title">
                <div class="tools" @click.prevent="collapse">
                    <i :class="collapsed?'el-icon-s-unfold':'el-icon-s-fold'"></i>
                </div>

                <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-inner" style="width: 6em">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                </el-breadcrumb>

            </el-col>
            <div class="userinfo">
                <div class="userinfo-name">{{ preset.app.name }}</div>
            </div>
        </el-col>
        <el-col :span="24" class="main">
            <aside :class="$organization.menu_class + ' ' + (collapsed?'menu-collapsed':'menu-expanded')"
                   style="position: absolute;z-index: 99;overflow: hidden; height: 100%">
                <!--导航菜单-->
                <el-menu style="height: 100%; overflow-x: hidden; overflow-y: auto"
                         :default-active="$route.path"
                         @select="handleSelect"
                         :class="$organization.menu_class"
                         :collapse="collapsed"
                         unique-opened router
                >
                    <template v-for="(item) in menu">
                        <el-submenu :index="item.name" v-if="item.children" :key="item.name">
                            <template slot="title"><i :class="item.icon"></i>
                                <span slot="title">{{ item.name }}</span>
                            </template>
                            <el-menu-item v-for="child in item.children" :index="child.path" :key="child.name">
                                <i v-if="child.icon" :class="child.icon"></i><span slot="title">{{ child.name }}</span>
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="!item.children" :index="item.path" :key="item.name">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.name }}</span>
                        </el-menu-item>
                    </template>
                </el-menu>

            </aside>
            <section class="content-container" style="background-color: #f9fafb; height: 100%">
                <div class="grid-content bg-purple-light h-100">
                    <el-col :span="24" class="breadcrumb-container">
                        <div class="d-flex justify-content-between">
                            <strong class="title"><i class="el-icon-back" style="cursor:pointer"
                                                     @click="$router.back()"></i>
                                <span class="title-divider"></span> <span class="ml-3">{{ ($route.meta && $route.meta.nickname) ? $route.meta.nickname :$route.name }}</span>
                            </strong>                            <announcement></announcement>
                        </div>
                    </el-col>
                    <el-col :span="24" class="content-wrapper"
                            style="padding-top: 5px;height: calc(100% - 30px);overflow: auto">
                        <keep-alive>
                            <router-view class="h-100" :key="pageKey"
                                         v-if="$route.meta && $route.meta.keepAlive"></router-view>
                        </keep-alive>
                        <router-view class="h-100" :key="pageKey"
                                     v-if="!($route.meta && $route.meta.keepAlive)"></router-view>
                    </el-col>
                </div>
            </section>
        </el-col>
        <disclaimer></disclaimer>
    </el-row>
</template>

<script>

import Announcement from "@/components/announcememt";
import Disclaimer from "@/components/disclaimer";
import "@/views/scss/web-home.scss";
import HomeMixin from "@/views/mixins/home-mixin";

export default {
    components: { Disclaimer, Announcement},
    mixins: [HomeMixin],

}

</script>
